<template>
    <div class="DateTimePicker__mask" v-on:click.self="hide()">
        <div class="DateTimePicker">

            <!--HEADER-->
            <DateTimePickerHeader />

            <!--MONTH PICKER-->
            <DateTimePickerMonthPicker />

            <div class="DateTimePicker__body">

                <!--MONTH VIEW-->
                <DateTimePickerMonth />

                <template v-if="showTime">

                    <!--TIME PICKER-->
                    <DateTimePickerTime />

                    <!--TIMELINE-->
                    <DateTimePickerTimeLine />

                </template>
            </div>
            <div class="DateTimePicker__bottom">

                <!--CLOSE-->
                <BaseButtonFlat :label="'COMMON__CLOSE'"
                                :class-name="'DateTimePicker__back'"
                                @click="hide()" />

                <!--SAVE-->
                <BaseButton :label="'COMMON__OK'"
                            :class-name="'DateTimePicker__ok'"
                            :accent="true"
                            @click="ok()" />

            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import DateTimePickerHeader from './DateTimePickerHeader.vue';
    import DateTimePickerMonthPicker from './DateTimePickerMonthPicker.vue';
    import DateTimePickerMonth from './DateTimePickerMonth.vue';
    import DateTimePickerTime from './DateTimePickerTime.vue';
    import DateTimePickerTimeLine from './DateTimePickerTimeLine.vue';
    import BaseButton from './../BaseButton.vue';
    import BaseButtonFlat from './../BaseButtonFlat.vue';

    export default {
        name: 'DateTimePicker',
        components: {
            DateTimePickerHeader,
            DateTimePickerMonthPicker,
            DateTimePickerMonth,
            DateTimePickerTime,
            DateTimePickerTimeLine,
            BaseButton,
            BaseButtonFlat
        },
        computed: {
            ...mapState({
                showTime: s => s.dateTimePicker.showTime
            })
        },
        methods: {
            ...mapActions({
                hide: 'dateTimePicker/hide',
                ok: 'dateTimePicker/ok'
            })
        }
    };
</script>

<style>
    .DateTimePicker__mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        padding-top: 30px;
        overflow: auto;
        background-color: rgba(0, 0, 0, .5);
    }

    @media (max-width: 599px) {
        .DateTimePicker__mask {
            padding: 0;
        }
    }

    .DateTimePicker {
        position: relative;
        background-color: #fff;
        width: 600px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    }

    .DateTimePicker__body {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        padding: 10px;
    }

    .DateTimePicker__bottom {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content:space-between;
        padding: 0 10px 10px 10px;
    }

    .DateTimePicker__ok {
        display: block;
        flex: 0 0 auto;
    }

    .DateTimePicker__back {
        display: block;
        flex: 0 0 auto;
        margin-right: 8px;
    }

    @media (max-width: 600px) {
        .DateTimePicker {
            width: 100%;
            min-height: 100%;
        }

        .DateTimePicker__ok {
            display: none;
        }

        .DateTimePicker__back {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// DateTimePicker.vue?1857b2c1